module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_8017.f995e6f9.png";